<template>
  <div>
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-notice-app-container-detail">
      <div class="ccui-notice-app-container-detail-body clearfix">
        <div class="ccui-notice-app-container-detail-left">
          <div class="notice-title">{{ schemeObj.schemeName }}</div>
          <div class="notice-project-info">
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.projectCode") }}：</span>{{ schemeObj.schemeCode }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishTime") }}：</span>{{ schemeObj.noticeStartTime }}
            </div>
            <!-- <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishUnit") }}：</span
              >{{ schemeObj.opUnitName }} 
            </div> -->
          </div>
        </div>
        <div class="ccui-notice-app-container-detail-right" v-if="
          isShow1 == true && isShow2 == true && $route.query.purchaseType != 92">
          <template v-if="$route.query.purchaseType == '97'">
            <template v-if="schemeObj.isNotShowTime != '1'">
              <!--<template v-if="noticeStatus === '3'">-->
              <!--<div class="notice-timeout-label">-->
              <!--{{ $t("page.content.signUpEndTime") }}-->
              <!--</div>-->
              <!--<div class="notice-timeout-value">-->
              <!--<i class="el-icon-time notice-icon-time"></i-->
              <!--&gt;<span class="time">{{ 0 }}</span-->
              <!--&gt;{{ $t("page.content.day") }}<span class="time">{{ 0 }}</span-->
              <!--&gt;{{ $t("page.content.hour") }}<span class="time">{{ 0 }}</span-->
              <!--&gt;{{ $t("page.content.minute")-->
              <!--}}<span class="time">{{ 0 }}</span-->
              <!--&gt;{{ $t("page.content.second") }}-->
              <!--</div>-->
              <!--</template>-->
              <template>
                <div class="notice-timeout-label">
                  {{ $t("page.content.signUpEndTime") }}
                </div>
                <div class="notice-timeout-value">
                  <i class="el-icon-time notice-icon-time"></i><span class="time">{{ timeObj.day }}</span>{{
                    $t("page.content.day")
                  }}<span class="time">{{ timeObj.hour }}</span>{{ $t("page.content.hour")
                  }}<span class="time">{{ timeObj.minute }}</span>{{ $t("page.content.minute")
                  }}<span class="time">{{ timeObj.second }}</span>{{ $t("page.content.second") }}
                </div>
              </template>
            </template>
          </template>
          <template v-else>
            <template v-if="schemeObj.isNotShowTime != '1'">
              <div class="notice-timeout-label">
                {{ $t("page.content.signUpEndTime") }}
              </div>
              <div class="notice-timeout-value">
                <i class="el-icon-time notice-icon-time"></i><span class="time">{{ timeObj.day }}</span>{{
                  $t("page.content.day")
                }}<span class="time">{{ timeObj.hour }}</span>{{ $t("page.content.hour")
                }}<span class="time">{{ timeObj.minute }}</span>{{ $t("page.content.minute")
                }}<span class="time">{{ timeObj.second }}</span>{{ $t("page.content.second") }}
              </div>
            </template>
          </template>

          <!--          <el-button-->
          <!--            class="notice-timeout-btn"-->
          <!--            size="mini"--> 
          <!--            type="primary-font-mini"-->
          <!--            :disabled="-->
          <!--              this.$route.query.schemeStatus !== '3' ||-->
          <!--                (this.checkFlag !== '2' &&-->
          <!--                  this.checkFlag !== '4' &&-->
          <!--                  this.checkFlag !== '5')-->
          <!--            "-->
          <!--            @click="-->
          <!--              signUp({-->
          <!--                schemeId: $route.query.schemeId,-->
          <!--                purchaseType: $route.query.purchaseType,-->
          <!--                noticeStartTime: schemeObj.noticeStartTime,-->
          <!--                schemeCode: schemeObj.schemeCode,-->
          <!--                schemeName: schemeObj.schemeName,-->
          <!--                supName: $route.query.supName,-->
          <!--                supCode: $route.query.supCode-->
          <!--              })--> 
          <!--            "-->
          <!--            >{{ $t("page.content.immediatelySignUp") }}</el-button-->
          <!--          >-->
          <el-button v-if="
            $route.query.purchaseType !== '5' &&
            $route.query.purchaseType !== '8'
          " :class="[
            languagezh_cn ? 'notice-timeout-btn' : 'notice-timeout-btnEn',
            schemeObj.isNotShowTime == '1' ? 'notice-timeout-btn-bottom' : ''
          ]" size="mini" type="primary-font-mini" :disabled="$route.query.schemeStatus !== '3' ||
            (checkFlag !== '2' && checkFlag !== '5')
            " @click="
              signUp({
                schemeId: $route.query.schemeId,
                purchaseType: $route.query.purchaseType,
                noticeStartTime: schemeObj.noticeStartTime,
                schemeCode: schemeObj.schemeCode,
                schemeName: schemeObj.schemeName,
                supName: $route.query.supName,
                supCode: $route.query.supCode
              })
              ">
            {{
              checkFlag === "3"
                ? $t("page.content.yicanyu")
                : $t("page.content.immediatelySignUp")
            }}
          </el-button>
          <!-- this.checkFlag !== '4' && -->
          <template v-else>
            <template v-if="
              supInfo.getSupInfoByLoginInfoRspBOList &&
              supInfo.getSupInfoByLoginInfoRspBOList.length > 0
            ">
              <el-button :class="[
                languagezh_cn ? 'notice-timeout-btn' : 'notice-timeout-btnEn',
                schemeObj.isNotShowTime == '1'
                  ? 'notice-timeout-btn-bottom'
                  : ''
              ]" size="mini" type="primary-font-mini" v-if="
                !(
                  $route.query.schemeStatus !== '3' ||
                  (checkFlag !== '2' && checkFlag !== '5')
                )
              " @click="
                signUp({
                  schemeId: $route.query.schemeId,
                  purchaseType: $route.query.purchaseType,
                  noticeStartTime: schemeObj.noticeStartTime,
                  schemeCode: schemeObj.schemeCode,
                  schemeName: schemeObj.schemeName,
                  supName: $route.query.supName,
                  supCode: $route.query.supCode
                })
                ">{{ $t("page.content.immediatelySignUp") }}</el-button>
              <!--进入项目     -->
              <template v-else-if="
                checkFlag !== '1' &&
                checkFlag !== '4' &&
                checkFlag !== '8' &&
                $route.query.schemeStatus !== '5'
              ">
                <el-button :class="[
                  languagezh_cn
                    ? 'notice-timeout-btn'
                    : 'notice-timeout-btnEn',
                  schemeObj.isNotShowTime == '1'
                    ? 'notice-timeout-btn-bottom'
                    : ''
                ]" size="mini" type="primary-font-mini" @click="
                  toProject({
                    schemeId: $route.query.schemeId,
                    purchaseType: $route.query.purchaseType,
                    noticeStartTime: schemeObj.noticeStartTime,
                    noticeEndTime: schemeObj.noticeEndTime,
                    schemeCode: schemeObj.schemeCode,
                    schemeName: schemeObj.schemeName,
                    supName: $route.query.supName,
                    supCode: $route.query.supCode
                  })
                  ">{{ $t("page.content.toMyProject") }}</el-button>
              </template>
              <template v-else>
                <el-button :class="[
                  languagezh_cn
                    ? 'notice-timeout-btn'
                    : 'notice-timeout-btnEn',
                  schemeObj.isNotShowTime == '1'
                    ? 'notice-timeout-btn-bottom'
                    : ''
                ]" size="mini" type="primary-font-mini" :disabled="true">{{ $t("page.content.immediatelySignUp")
                }}</el-button>
              </template>
            </template>
            <template v-else>
              <template v-if="$route.query.purchaseType === '8'">
                <template v-if="schemeObj.isNotShowTime != '1'">
                  <div class="notice-timeout-label">
                    {{ $t("page.content.signUpEndTime") }}
                  </div>
                  <div class="notice-timeout-value">
                    <i class="el-icon-time notice-icon-time"></i><span class="time">{{ timeObj.day }}</span>{{
                      $t("page.content.day")
                    }}<span class="time">{{ timeObj.hour }}</span>{{ $t("page.content.hour")
                    }}<span class="time">{{ timeObj.minute }}</span>{{ $t("page.content.minute")
                    }}<span class="time">{{ timeObj.second }}</span>{{ $t("page.content.second") }}
                  </div>
                </template>
                <el-button :class="[
                  languagezh_cn
                    ? 'notice-timeout-btn'
                    : 'notice-timeout-btnEn',
                  schemeObj.isNotShowTime == '1'
                    ? 'notice-timeout-btn-bottom'
                    : ''
                ]" size="mini" type="primary-font-mini" :disabled="$route.query.schemeStatus !== '3' ||
                  (checkFlag !== '2' && checkFlag !== '5')
                  " @click="
                    signUp({
                      schemeId: $route.query.schemeId,
                      purchaseType: $route.query.purchaseType,
                      noticeStartTime: schemeObj.noticeStartTime,
                      schemeCode: schemeObj.schemeCode,
                      schemeName: schemeObj.schemeName,
                      supName: $route.query.supName,
                      supCode: $route.query.supCode
                    })
                    ">{{ $t("page.content.immediatelySignUp") }}</el-button>
              </template>
              <template v-else>
                <el-button :class="[
                  languagezh_cn
                    ? 'notice-timeout-btn'
                    : 'notice-timeout-btnEn',
                  schemeObj.isNotShowTime == '1'
                    ? 'notice-timeout-btn-bottom'
                    : ''
                ]" size="mini" type="primary-font-mini" v-if="
                  !(
                    $route.query.schemeStatus !== '3' ||
                    (checkFlag !== '2' && checkFlag !== '5')
                  )
                " @click="
                  signUp({
                    schemeId: $route.query.schemeId,
                    purchaseType: $route.query.purchaseType,
                    noticeStartTime: schemeObj.noticeStartTime,
                    schemeCode: schemeObj.schemeCode,
                    schemeName: schemeObj.schemeName,
                    supName: $route.query.supName,
                    supCode: $route.query.supCode
                  })
                  ">{{ $t("page.content.immediatelySignUp") }}</el-button>
                <!--进入项目-->
                <template v-else-if="
                  checkFlag !== '1' &&
                  checkFlag !== '4' &&
                  checkFlag !== '8' &&
                  $route.query.schemeStatus !== '5'
                ">
                  <el-button :class="[
                    'notice-timeout-btn',
                    schemeObj.isNotShowTime == '1'
                      ? 'notice-timeout-btn-bottom'
                      : ''
                  ]" size="mini" type="primary-font-mini" @click="
                    toProject({
                      schemeId: $route.query.schemeId,
                      purchaseType: $route.query.purchaseType,
                      noticeStartTime: schemeObj.noticeStartTime,
                      noticeEndTime: schemeObj.noticeEndTime,
                      schemeCode: schemeObj.schemeCode,
                      schemeName: schemeObj.schemeName,
                      supName: $route.query.supName,
                      supCode: $route.query.supCode
                    })
                    ">{{ $t("page.content.toMyProject") }}</el-button>
                </template>
                <template v-else>
                  <el-button :class="[ 
                    languagezh_cn
                      ? 'notice-timeout-btn'
                      : 'notice-timeout-btnEn',
                    schemeObj.isNotShowTime == '1'
                      ? 'notice-timeout-btn-bottom'
                      : ''
                  ]" size="mini" type="primary-font-mini" :disabled="true">{{ $t("page.content.immediatelySignUp")
                  }}</el-button>
                </template>
              </template>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="template-notice-detail-body ccui-clearfix">
      <!--左侧内容-->
      <div class="template-notice-detail-left" :style="{
        'min-height': leftMinHeight,
        width: '1120px'
      }">
        <div class="notice-detail-title">{{ $t("page.content.notice") }}</div>
        <div class="notice-detail-ul clearfix">
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title">{{ $t("page.content.noticeTitle") }}：</span>
            <div class="notice-detail-li-con">{{ pageData.noticeTitle }}</div>
          </div>
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title">{{ $t("page.content.noticeContent") }}：</span>
            <div class="notice-detail-li-con rich-text" v-html="pageData.textInfo"></div>
          </div>
          <div class="notice-detail-li ccui-clearfix" v-if="
            $route.query.purchaseType === '90' ||
            $route.query.purchaseType === '93'
          ">
            <span class="notice-detail-li-title">{{ $t("page.content.contractInfo") }}：</span>
            <div class="notice-detail-li-con rich-text" v-html="pageData.linkInfo"></div>
          </div>
        </div>
        <div class="notice-detail-title" style="padding-top: 40px;">
          {{ $t("page.content.fileList") }}
          <!-- <span class="notice-detail-title-tip">
            <el-link type="danger" @click="handleProcess">{{
              $t("page.content.supplierBiddingProcess")
            }}</el-link>
            <span class="fontsize-14"
              >（{{ $t("page.content.pleaseClickView") }}）</span
            >
          </span> -->
        </div>

        <detailTable class="dic-sub-table-style01" :tableData="pageData.fileinfoBOS" :tableHead="fileHead"
          :showIndex="true"></detailTable>

        <div>
          <!--包件信息-->
          <template v-for="(item, index) in packageList">
            <div :key="index">
              <template v-if="subPackageFlag === '1'">
                <div class="notice-detail-title mt20 ellipsis" :title="item.packName">
                  {{ item.packName }}
                </div>
                <div class="notice-detail-explain ccui-clearfix">
                  <div class="fl">{{ $t("page.content.packageDesc") }}：</div>
                  <div style="line-break: anywhere;">
                    {{ item.packRequire }}
                  </div>
                </div>
              </template>
              <div class="notice-detail-title pt20" v-else></div>
              <template v-if="item.matDetailList.length > 0">
                <div class="notice-detail-subtitle">
                  {{ $t("page.content.materialInfo") }}
                </div>
                <detailTable class="dic-sub-table-style01" :tableData="item.matDetailList" :tableHead="packageHead"
                  :showIndex="true"></detailTable>
              </template>
            </div>
          </template>
        </div>
        <div class="notice-detail-title pt20">
          {{ $t("page.content.relatedNoticeList") }}
        </div>
        <detailTable class="dic-sub-table-style01" :tableData="relateNoticeList" :tableHead="noticeHead"
          :showIndex="true">
          <template slot="noticeTitle" slot-scope="{ row }">
            <el-button size="mini" type="text" @click="handleNoticeTitle(row)">
              {{ row.noticeTitle }}
            </el-button>
          </template>
        </detailTable>
      </div>

      <!--右侧内容-->
      <!--
      <div class="template-notice-detail-right" ref="rightBox">
        <svg-icon icon-class="logoDetail"></svg-icon>
        <div class="detail-info-right-box">
          <div class="logo-detail">
            <img
              :src="require('@/basa/assets/images/littleLogo.png')"
              class="svg-icon"
            />
            <div class="detail-info-right-box-title">
              {{ schemeObj.opUnitName }}
            </div>
          </div>
          <el-divider></el-divider>
          <div class="detail-info-right-box-subtitle">
            {{ $t("page.content.purchaseMoney") }}
          </div>
          <div class="detail-info-right-box-subbox clearfix">
            <span class="purchase-money ellipsis" :title="cumulativeAmount">{{
              cumulativeAmount
            }}</span
            ><span
              class="purchase-money-unit ell"
              :title="$t('page.content.thousandYuan')"
              >{{ $t("page.content.thousandYuan") }}</span
            >
          </div>
          <div class="detail-info-right-box-total clearfix">
            <div class="detail-info-right-box-total-label ell">
              {{ $t("page.content.camulativePurchaseItems") }}
            </div>
            <div class="detail-info-right-box-total-value">
              {{ projectNum }} 个
            </div>
          </div>

          <div class="detail-info-right-box-total clearfix">
            <div class="detail-info-right-box-total-label ell">
              {{ $t("page.content.inquiryProjectNum") }}
            </div>
            <div class="detail-info-right-box-total-value">
              {{ inquiryProjectNum }} 个
            </div>
          </div>

          <div class="detail-info-right-box-total clearfix">
            <div class="detail-info-right-box-total-label ell">
              {{ $t("page.content.biddingProjectNum") }}
            </div>
            <div class="detail-info-right-box-total-value">
              {{ competeProjectNum }} 个
            </div>
          </div>
        </div>

        <div class="detail-info-right-other" v-if="otherNoticeList.length > 0">
          <div class="detail-info-right-title ccui-clearfix">
            <span class="fl">{{ $t("page.content.unitStillPurchase") }}</span>
            <a class="fr" @click="handleViewCommendUnit"
              >{{ $t("page.content.MoreAndMore") }} ></a
            >
          </div>
          <template v-for="(item, index) in otherNoticeList">
            <div
              class="detail-info-right-other-box notice-detail-box-out"
              :key="index"
              @click="handleView(item)"
            >
              <notice-item-block :data="item"></notice-item-block>
            </div>
          </template>
        </div>
      </div>
      -->
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import detailTable from "@/app/shop/components/detail-table";
import { commonTableWidth } from "@/setting/setting";
import { announcementStatus } from "@/setting/setting";
// import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
import globalConfig from "@/setting/setting";

import {
  qryNoticeDetail,
  queryProcessSchemeMatDetail,
  qryRelatedNoticeList,
  // qryUnitAmountAndProjectNum,
  // listOpUnitBidNotice,
  getSystemCurrentTime,
  qrySupJoinCheckNew,
  queryPurchaseSchemeDetailBasic
} from "@/app/shop/api/shopping";
export default {
  name: "noticeDetail",
  mixins: [mixinHomePage],
  components: {
    baseBreadCrumb,
    detailTable
    // noticeItemBlock
  },
  data() {
    return {
      currBreadCrumb: [],
      fileHead: [
        { label: this.$t("page.content.fileName"), prop: "fileName" },
        { label: this.$t("page.content.fileDesc"), prop: "fileSumm" },
        {
          label: this.$t("page.content.operation"),
          slot: "opp",
          align: "center",
          width: this.$TW.operationWidth
        }
      ],
      packageHead: [
        { label: this.$t("page.content.equipmentName"), prop: "matName" },
        {
          label: this.$t("page.content.equipmentDesc"),
          prop: "matDesc",
          width: this.$TW.equipmentDescWidth
        },
        { label: this.$t("page.content.num"), prop: "convNum" },
        { label: this.$t("page.content.unit"), prop: "convMeasureUnitName" }
      ],
      noticeHead: [
        {
          label: this.$t("page.content.type"),
          prop: "noticeTypeName",
          width: 150
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          slot: "noticeTitle"
        },
        // {
        //   label: this.$t("page.content.link"),
        //   prop: "purStepName",
        //   width: 150
        // },
        {
          label: this.$t("page.content.publishTime"),
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      packageList: [],
      matDetailList: [],
      pageData: {},
      relateNoticeList: [], //相关公告列表
      schemeObj: {
        opUnitName: this.$route.query.opUnitName, //发布单位
        schemeName: this.$route.query.schemeName, //项目名称
        schemeCode: this.$route.query.schemeCode //项目编号
      },
      cumulativeAmount: 0, //累计金额
      projectNum: 0, //累计采购项目数
      inquiryProjectNum: 0, //询价项目数量
      competeProjectNum: 0, //竞价项目数量
      otherNoticeList: [], //该单位还在采购的公告列表
      noticeEndTime: "",
      currentTime: "",
      timeObj: {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0
      },
      timer: "",
      timerHttp: "",
      leftMinHeight: 0,
      noticeStatus: "",
      checkFlag: "",
      supInfo: this.$store.state.user.supInfo || {},
      accessToken: this.$store.state.user.accessToken,
      isShow1: false,
      isShow2: false
    };
  },
  computed: {
    languagezh_cn() {
      return 'en-gb' === "zh-cn";
    }
  },
  activated() {
    this.init();
  },
  deactivated() {
    this.currBreadCrumb = [];
    clearInterval();
  },
  methods: {
    init() {
      this.isShow1 = false;
      this.isShow2 = false;
      // let supCodeList = [];
      // if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
      //   supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
      //     return item.supCode;
      //   });
      // }
      let supCode = "";
      if (this.supInfo?.getSupInfoByLoginInfoRspBOList) {
        supCode = this.supInfo.getSupInfoByLoginInfoRspBOList[0]?.supCode;
      }
      supCode = this.supInfo?.supCode || supCode;
      //登录情况下查询
      if (
        this.accessToken &&
        this.supInfo.getSupInfoByLoginInfoRspBOList.length > 0
      ) {
        //查询供应商是否可参与
        qrySupJoinCheckNew({
          schemeId: this.$route.query.schemeId,
          supCode: supCode
          //supCode: this.$route.query.supCode,
          //supCodeList: this.$route.query.supCode ? [] : supCodeList
        }).then(res => {
          if (res.data.code === "0") {
            if (res.data.data.checkFlag == 3) {
              this.toProjectLocation({
                schemeId: this.$route.query.schemeId,
                purchaseType: this.$route.query.purchaseType,
                noticeStartTime: this.schemeObj.noticeStartTime,
                noticeEndTime: this.schemeObj.noticeEndTime,
                schemeCode: this.schemeObj.schemeCode,
                schemeName: this.schemeObj.schemeName,
                supName: this.$route.query.supName,
                supCode: this.$route.query.supCode
              });
            }
            this.checkFlag = res.data.data.checkFlag;
            this.isShow1 = true;
          }
        });
      } else {
        this.isShow1 = true;
      }


      queryPurchaseSchemeDetailBasic({
        schemeId: this.$route.query.schemeId,
        pageNo: -1,
        pageSize: -1,
        purSupFlag: "pur"
      }).then(res => {
        let obj = res.data.data;
        sessionStorage.setItem(
          this.$route.query.schemeId + "timeZone",
          obj.timeZone
        );
        sessionStorage.setItem(
          this.$route.query.schemeId + "timeZoneName",
          obj.timeZoneName
        );
      })

      //查询公告信息及附件列表
      qryNoticeDetail({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId,
        // purStep: 1,
        qryFileFlag: true
      }).then( async res => {
        if (res.data.code === "0" && res.data.data) {
          this.pageData = res.data.data;
          this.$set(
            this.noticeHead[2],
            "isHidden",
            this.pageData.purStep !== "1"
          );
          this.currBreadCrumb.push({
            title: this.pageData.noticeTitle
          });
          this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
          this.noticeEndTime = this.pageData.firstRoundEndTime;
          const timeZone = sessionStorage.getItem(
              this.$route.query.schemeId  + "timeZone"
            );
          let zz = await getSystemCurrentTime({ timeZone: timeZone || "" });
          this.currentTime =
            this.UTCToLocalTimeString(zz.data) || this.timeInOtherZone();
          this.schemeObj.isNotShowTime = this.pageData.isNotShowTime;
          clearInterval(this.timer);
          let that = this;
          this.timer = setInterval(that.getTime, 1000);
          //每隔10s请求一次接口同步下时间，因为窗口切换后浏览器基于节约资源定时器会有延迟
          clearInterval(that.getTimerHttp);
          this.timerHttp = setInterval(that.getTimerHttp, 30000);
          this.noticeStatus = this.pageData.noticeStatus;
          this.isShow2 = true;
        }
      });
      //查询包件信息
      queryProcessSchemeMatDetail({
        schemeId: this.$route.query.schemeId
      }).then(res => {
        if (res.data.code === "0") {
          this.subPackageFlag = res.data.data.subPackageFlag;
          if (this.subPackageFlag === "0") {
            this.packageList = [{
              matDetailList: res.data.data.matDetailList.map(item => {
                console.log(item, 'itemitemitem');

                if (item.matNameEn) {
                  item.matName = item.matNameEn
                }
                if (item.convMeasureUnitNameEn) {
                  item.convMeasureUnitName = item.convMeasureUnitNameEn
                }
                return item
              })
            }];
            console.log(this.packageList, 'this.packageList  this.packageList');
          } else {
            this.packageList = res.data.data.packageList;
            this.packageList.forEach(item => {
              item.matDetailList.forEach(i => {
                if (i.matNameEn) {
                  i.matName = i.matNameEn
                }
                if (i.convMeasureUnitNameEn) {
                  i.convMeasureUnitName = i.convMeasureUnitNameEn
                }
              })
            });
            console.log(this.packageList, 'this.packageList  this.packageList1111');
          }
        }
      });
      //查询相关公告列表
      qryRelatedNoticeList({
        schemeId: this.$route.query.schemeId,
        noticeId: this.$route.query.noticeId
      }).then(res => {
        if (res.data.code === "0") {
          this.relateNoticeList = res.data.data.map(item => {
            item.noticeTypeName = announcementStatus[item.noticeTypeName] || ''
            return item
          });
        }
      });

      // 单位累计金额和项目数量查询
      // qryUnitAmountAndProjectNum({
      //   opUnitId: this.$route.query.opUnitId
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.cumulativeAmount = window.$computeUtil.getDividedToFormat(
      //       res.data.data.cumulativeAmount,
      //       10000
      //     );
      //     this.projectNum = res.data.data.projectNum;
      //     this.inquiryProjectNum = res.data.data.inquiryProjectNum;
      //     this.competeProjectNum = res.data.data.competeProjectNum;
      //   }
      // });

      //查询该单位还在采购的公告
      // listOpUnitBidNotice({
      //   pageNo: 1,
      //   pageSize: 2,
      //   purchaseType: this.$route.query.purchaseType,
      //   opUnitId: this.$route.query.opUnitId,
      //   noticeId: this.$route.query.noticeId,
      //   supCode: this.$store.state.user.supInfo.supCode
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.otherNoticeList = res.data.data.rows;
      //     this.$nextTick(() => {
      //       this.leftMinHeight = this.$refs.rightBox
      //         ? this.$refs.rightBox.clientHeight - 60 + "px"
      //         : "0";
      //     });
      //   }
      // });
    },
    getTimerHttp() {
      const timeZone = sessionStorage.getItem(
        this.$route.query.schemeId  + "timeZone"
      );
      getSystemCurrentTime({  timeZone: timeZone || ""}).then(res => {
        if (res.headers.date) {
          this.currentTime =
            this.UTCToLocalTimeString(res.data) || this.timeInOtherZone();
        }
      });
    },
    UTCToLocalTimeString(d) {
      let date = new Date(d);
      // let timeOffsetInHours = new Date().getTimezoneOffset() / 60 + 8; //这里的 8是时区，东八区为北京时间，PS：东区为正数 西区为负数
      // date.setHours(date.getHours() + timeOffsetInHours);
      // console.log(date, "这是转东八区后的d", date.getTime());
      return date.getTime();
    },
    getTime() {
      let obj =
        (new Date(
          (this.noticeEndTime ?? "2000-01-01").replace(/-/g, "/")
        ).getTime() -
          this.currentTime) *
        1000;
      if (obj < 0) {
        clearInterval(this.timer);
        clearInterval(this.getTimerHttp);
        return;
      }
      let day = Math.floor(obj / (24 * 3600 * 1000 * 1000));

      let leave1 = obj % (24 * 3600 * 1000 * 1000);
      let hour = Math.floor(leave1 / (3600 * 1000 * 1000));
      let leave2 = leave1 % (3600 * 1000 * 1000);
      let minutes = Math.floor(leave2 / (60 * 1000 * 1000));

      let leave3 = leave2 % (60 * 1000 * 1000);
      let second = Math.floor(leave3 / (1000 * 1000));

      this.timeObj.day = day;
      this.timeObj.hour = hour;
      this.timeObj.minute = minutes;
      this.timeObj.second = second;
      this.currentTime += 1000;
    },

    //供应商在线投标流程
    handleProcess() {
      let url = this.$router.resolve({
        path: "/announcementDetail",
        query: {
          id: globalConfig.faqId,
          source: "1"
        }
      });
      window.open(url.href, "_blank");
    },
    timeInOtherZone() {
      const date = new Date();
      const timeZone = sessionStorage.getItem(
        this.$route.query.schemeId  + "timeZone"
      );
      // 获取东八区时间（北京时间）

      const options = {
        timeZone: timeZone,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      };
      const timeInOtherZone = new Intl.DateTimeFormat("en-US", options).format(
        date
      );
      const dateFromFormatted = new Date(timeInOtherZone);

      // 获取时间戳（单位：毫秒）
      const timestamp = dateFromFormatted.getTime();
      return timestamp;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.getTimerHttp);
  }
};
</script>

<style scoped lang="scss">
.template-detail-body .detail-box .detail-info {
  width: calc(100% - 240px);
}

/deep/ .template-detail-body .detail-box {
  margin-top: 20px;
  margin-bottom: 0;
}

/deep/ .ccui-notice-app-container-detail .ccui-notice-app-container-detail-body .ccui-notice-app-container-detail-right {
  width: inherit;

  .notice-timeout-btnEn {
    width: 228px;
  }

  .notice-timeout-btn-bottom {
    margin-top: 90px;
  }
}

.time {
  color: #ff142f;
  margin-left: 8px;
  margin-right: 8px;
}
</style>
